import axios from 'axios';
import { SERVER_URL } from "../const";



export const getAllScripTransactionService = async () => {
  const token = localStorage.getItem('token');
    try {
      // Make a GET request to fetch Rodtep data based on the IEC number
      const response = await axios.get(`${SERVER_URL}/scrip-transactions`, {
          headers: { 'Authorization': `Bearer ${token}` }
        });
      return response.data; // Return the data from the response
    } catch (error) {
        console.error('Error fetching Rodtep data:', error);
    //   throw new Error('Error fetching Rodtep data:', error);
    }
  };